<template>
  <RenewalTable :data="data">
    <template #header>
      <Grid gaf="column" justify-content="space-between" align-items="center">
        <div class="text-subtitle-1 text-secondary-2">{{ departmentLabel.singular }} spend overview</div>

        <Grid gaf="column" gap="var(--r-space-sm)">
          <RDropdown
            v-model="selectedDepartmentId"
            :options="departmentsOptions"
            :loading="!departments"
            no-hint
            no-label
            option-value="id"
            option-label="name"
            emit-value
            map-options
            no-options-sort
            style="min-width: 200px"
          />

          <ExportBtn :loading="exportLoading" @click="onExport" />
        </Grid>
      </Grid>
    </template>
  </RenewalTable>
</template>

<script>
import * as apiTo from '@/modular-api'
import { downloadFile } from '@lib/generic.utils'
// Libraries
import { mapGetters } from 'vuex'
// Components
import RenewalTable from '@/reusable/renewal-table/RenewalTable'
import ExportBtn from '@/reusable/ExportBtn'

export default {
  components: {
    RenewalTable,
    ExportBtn
  },

  data: () => ({
    data: null,
    departments: null,
    selectedDepartmentId: null,
    exportLoading: false
  }),

  computed: {
    ...mapGetters('entity-labels', ['departmentLabel']),

    departmentsOptions() {
      if (!this.departments) return []

      return [{ id: 0, name: `All ${this.departmentLabel.plural}` }, ...this.departments]
    }
  },

  created() {
    Promise.all([apiTo.GET_INFO_BOX_DEP_SPEND_OVERVIEW(null), apiTo.GET_DEPARTMENTS()]).then(
      ([{ data: spendOverviewApi }, { data: departmentsApi }]) => {
        this.data = spendOverviewApi.result
        this.departments = departmentsApi.result
        this.selectedDepartmentId = 0
        this.$watch('selectedDepartmentId', newVal => {
          this.getTableData(newVal || null)
        })
      }
    )
  },

  methods: {
    getTableData(depId = null) {
      this.data = null

      apiTo.GET_INFO_BOX_DEP_SPEND_OVERVIEW(depId).then(({ data }) => (this.data = data.result))
    },

    onExport() {
      this.exportLoading = true
      apiTo
        .DEPARTMENT_SPEND_OVERVIEW(this.selectedDepartmentId || '')
        .then(downloadFile)
        .finally(() => (this.exportLoading = false))
    }
  }
}
</script>
